<div class="passcode-container">
  <div class="shadow passcode-form">
    <form #passcodeForm="ngForm" (ngSubmit)="onSubmit(passcodeForm)">
      <div class="wrapper">
        <h2 class="title">Welcome Back</h2>

        <div class="error">{{ errorMessage }}</div>

        <div class="mb-2">
          <mat-form-field appearance="outline" class="full-width">
            <input
              aria-label="Passcode"
              matInput
              [type]="hide() ? 'password' : 'text'"
              autocomplete="one-time-code"
              placeholder="Passcode"
              [(ngModel)]="passcode"
              name="Passcode"
              spellcheck="false"
              required
            />
            <span matTextPrefix>
              <fa-icon class="icon" [icon]="['fas', 'lock']"></fa-icon>
            </span>
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="showPassword($event)"
              [attr.aria-label]="'Hide Passcode'"
              [attr.aria-pressed]="hide()"
            >
              <fa-icon
                class="icon"
                [icon]="['fas', hide() ? 'eye-slash' : 'eye']"
              ></fa-icon>
            </button>
            <mat-error> Please provide a valid passcode </mat-error>
          </mat-form-field>
        </div>

        <div>
          <button type="submit" color="primary" class="btn-submit">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
